const loginEndpoints = {
  login: '/login'
}

export default loginEndpoints
